import TextField from '@mui/material/TextField';
import { Box, CircularProgress } from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useTranslation } from 'react-i18next';
import { Linkedin } from '../../../../icons/linkedin';
import { BrokenImage } from '../../../../icons/broken-image';
import STRING_KEYS from '../../../../language/keys';
import NewTalentDialogError from '../NewTalentDialogError';
import { DialogStyle } from './style';

type NewTalentDialogContentProps = {
  error: boolean,
  linkedinUrl: string,
  onLinkedInValueChanged: (e:React.ChangeEvent<HTMLInputElement>) => void,
  isLoading: boolean,
  onCreateTalentManually: () => void,
  isPrivateProfile: boolean,
  errorMessage: string,
  }

const style = {
  loader: {
    sx: {
      position: 'absolute',
      top: '45%',
      left: '45%',
    },
  },
} as const;

export default function NewTalentDialogContent({
  linkedinUrl,
  error,
  onLinkedInValueChanged,
  isLoading,
  onCreateTalentManually,
  isPrivateProfile,
  errorMessage,
}:NewTalentDialogContentProps): JSX.Element {
  const { t: translate } = useTranslation();
  const serverError = error && !isPrivateProfile;
  const privateProfileError = error && isPrivateProfile;

  const defineInput = () => {
    return (
      <TextField
        error={ serverError }
        autoFocus
        helperText={ serverError && errorMessage }
        id="name"
        label={ translate(STRING_KEYS.TALENT_LINKEDIN_URL) }
        type="text"
        placeholder={ translate(STRING_KEYS.LINKEDIN_URL) }
        fullWidth
        variant="outlined"
        value={ linkedinUrl }
        onChange={ onLinkedInValueChanged }
        InputProps={ {
          startAdornment:
  <Linkedin
    style={  DialogStyle.linkedIn }
  />,
          style: serverError ? DialogStyle.errorInput : DialogStyle.inputColor,
        } }
      />
    );
  };

  const getContent = () => {
    return (
      <>
        <DialogContentText style={ DialogStyle.dialogContentText }>
          {translate(STRING_KEYS.LINKEDIN_PROFILE_MESSAGE)}
        </DialogContentText>
        {defineInput()}
        {privateProfileError && (
          <NewTalentDialogError
            Icon={ BrokenImage }
            onCreateTalentManually={ onCreateTalentManually }
            message={ translate(STRING_KEYS.LINKEDIN_DIALOG_ERROR) }
          />
        )}
      </>
    );
  };

  return (
    <DialogContent sx={ DialogStyle.dialogContent }>
      {isLoading ? (
        <Box sx={ style.loader.sx }>
          <CircularProgress />
        </Box>
      ) : getContent() }
    </DialogContent>
  );
}
